"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "settings.mailAccounts",
    path: "mail-accounts",
    component: "MailAccountConfigurations"
});
let MailAccountConfigurations = class MailAccountConfigurations extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    openMailAccountConfig(...args) {
        const [oid] = args;
        const updateItem = this.updateItem;
        return this.$imodal
            .show({
            name: 'MailAccountConfig',
            props: { oid }
        })
            .then(res => this.loadData('items'));
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    objectType;
    items;
    async $$load_items() {
        return this.$fn.fetch('list_object_by_type', { parameters: { object_type: this.$data.objectType } })
            .then(items => _.orderBy(items, ['created_at'], ['asc']));
    }
    ux;
    b_7315092382398562_modalBindings;
    b_3343864469950044_editable;
    b_3343864469950044_columns;
    dataMembers = ['objectType', 'items', 'ux', 'b_7315092382398562_modalBindings', 'b_3343864469950044_editable', 'b_3343864469950044_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                objectType: "mail-account",
                items: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_3343864469950044_editable: false,
                b_3343864469950044_columns: [{
                        name: "id",
                        header: this.$fn.pgettext("MailAccountConfig", "ID"),
                        width: "180px",
                        formatter: {
                            name: "template",
                            value: "<div>\n\
  <a class=\"text-nowrap\"\n\
     href=\"#\"\n\
     @click=\"globs.openMailAccountConfig(row.id)\"\n\
  >\n\
    {{ value }}\n\
  </a>\n\
</div>\n\
",
                        },
                    },
                    {
                        name: "address",
                        header: this.$fn.pgettext("MailAccountConfig", "Address"),
                        width: "180px",
                    },
                    {
                        name: "description",
                        header: this.$fn.pgettext("MailAccountConfig", "Description"),
                        width: "200px",
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return;
        }
        return null;
    }
    async act_7315092382398562_closeModal_4620_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_6705964765214521_script_4624_getActionArgs_value($event) {
        this.openMailAccountConfig();
    }
    async act_6705964765214521_script_4624_getActionArgs($event) {
        return {
            value: () => this.act_6705964765214521_script_4624_getActionArgs_value($event),
        };
    }
    async evh_6705964765214521_clickPreventStop(event, scope) {
        return await this.actions.evh_6705964765214521_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8116269939469002_showModal_4626_getActionArgs($event) {
        return {
            name: "FileSelector",
            props: {
                url: this.$fn.urlFor('import_mail_account_config'),
                accept: ".yaml",
            },
        };
    }
    async evh_8116269939469002_clickPreventStop(event, scope) {
        return await this.actions.evh_8116269939469002_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4620 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4620_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4619 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4620,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4619],
        });
        const act_8320016629450276_reloadComponentData_4622 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_8320016629450276_clickPreventStop_4621 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_reloadComponentData_4622,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_4621],
        });
        const act_6705964765214521_script_4624 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6705964765214521_script_4624_getActionArgs,
            events: [],
        });
        const evh_6705964765214521_clickPreventStop_4623 = new core_1.actions.EventHandlerImpl({
            action: act_6705964765214521_script_4624,
            event: "click.prevent.stop",
            displayName: "script",
        });
        const evh_6705964765214521_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6705964765214521_clickPreventStop_4623],
        });
        const act_8116269939469002_showModal_4626 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8116269939469002_showModal_4626_getActionArgs,
            events: [],
        });
        const evh_8116269939469002_clickPreventStop_4625 = new core_1.actions.EventHandlerImpl({
            action: act_8116269939469002_showModal_4626,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8116269939469002_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8116269939469002_clickPreventStop_4625],
        });
        return {
            act_7315092382398562_closeModal_4620,
            evh_7315092382398562_close_4619,
            evh_7315092382398562_close,
            act_8320016629450276_reloadComponentData_4622,
            evh_8320016629450276_clickPreventStop_4621,
            evh_8320016629450276_clickPreventStop,
            act_6705964765214521_script_4624,
            evh_6705964765214521_clickPreventStop_4623,
            evh_6705964765214521_clickPreventStop,
            act_8116269939469002_showModal_4626,
            evh_8116269939469002_clickPreventStop_4625,
            evh_8116269939469002_clickPreventStop,
            reload: act_8320016629450276_reloadComponentData_4622,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], MailAccountConfigurations.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MailAccountConfigurations.prototype, "onSize", null);
MailAccountConfigurations = __decorate([
    (0, vue_property_decorator_1.Component)()
], MailAccountConfigurations);
exports.default = MailAccountConfigurations;
vue_property_decorator_1.Vue.component("MailAccountConfigurations", MailAccountConfigurations);
